import React, { useEffect } from 'react';
import queryString from 'query-string';
import { useLocation, useHistory } from 'react-router-dom';
import { useRootStore } from '../../stores/BridgeProvider';
import Spinner from '../util/Spinner';

const XeroRefreshCallback = () => {
  const { push } = useHistory();
  const { search } = useLocation();
  const { authStore } = useRootStore();

  useEffect(() => {
    const xeroCallbackPost = async () => {
      try {
        const { data } = await authStore.request.post(
          `${process.env.REACT_APP_API}/api/re-auth-xero`,
          { confirmationCode: search },
        );
        // const { org_exists: orgExists } = data;
        // IF no org
        push('/organization');
      } catch (e) {
        console.error(e);
        // push('/select-organization');
      }
    };
    xeroCallbackPost();
  }, []);
  return <Spinner />;
};

export default XeroRefreshCallback;
